module.exports = __webpack_public_path__ + "img/btnmail.edd0efab.png";